import { themeUi } from '../../themeUi/themeUi';
import setupCompletenessBannerBg from '../../../../components/SetupCompleteness/SetupCompletenessBar/assets/setup-completeness-banner-light2.svg';

export const setupCompleteness = {
  setupCompletenessBar: {
    bannerCompose: {
      borderBottom: themeUi.semantic.color.border.secondary300,
      backgroundColor: themeUi.semantic.color.background.secondary0,
      backgroundImage: `url(${setupCompletenessBannerBg})`
    },
    bannerMessage: {
      color: themeUi.semantic.color.text.primary700
    }
  },

  setupCompletenessButton: {
    icon: {
      color: themeUi.semantic.color.icon.secondary800
    },
    badge: {
      border: themeUi.semantic.color.text.secondary50,
      backgroundColor: themeUi.semantic.color.text.success500
    }
  },

  setupCompletenessDrawer: {
    setupCompletenessDrawer: {
      title: {
        color: themeUi.semantic.color.text.secondary950
      },
      caption: {
        color: themeUi.semantic.color.text.secondary950
      },
      containerFooter: {
        backgroundColor: themeUi.semantic.color.background.primary50
      },
      footerText: {
        color: themeUi.semantic.color.text.secondary900
      },
      footerLink: {
        color: themeUi.semantic.color.text.primary600
      },
      line: {
        backgroundColor: themeUi.semantic.color.background.secondary300
      },
      collapseContainer: {
        backgroundColor: themeUi.semantic.color.background.secondary0,
        header: {
          backgroundColor: themeUi.semantic.color.background.secondary100,
          color: themeUi.semantic.color.text.secondary950,
          fill: themeUi.semantic.color.icon.neutral600,
          fontFamily: themeUi.core.font.fontFamily.regular
        }
      },
      collapseTitleCompleted: {
        color: themeUi.semantic.color.text.success600,
        backgroundColor: themeUi.semantic.color.background.success100,
        border: themeUi.semantic.color.border.success100
      },
      collapseTitleCompletedIcon: {
        fill: themeUi.semantic.color.icon.success600
      }
    },

    components: {
      setupCompletenessDrawerLink: {
        container: {
          backgroundColor: themeUi.semantic.color.background.secondary50,
          border: themeUi.semantic.color.border.secondary300
        },
        title: {
          color: themeUi.semantic.color.text.primary600
        },
        description: {
          color: themeUi.semantic.color.text.secondary900
        }
      },

      setupCompletenessDrawerTask: {
        container: {
          color: themeUi.semantic.color.text.secondary900
        },
        icon: {
          checkedFill: themeUi.semantic.color.icon.success500,
          notCheckedfill: themeUi.semantic.color.icon.secondary300
        },
        description: {
          color: themeUi.semantic.color.text.secondary900
        }
      }
    }
  }
};
